import { isFileSystemDirectoryEntry, readFilesFromDirectory, } from '#pplx/frontend/apps/ask/files/file-utils/fileUtils.js';
export function countFileDropItems(items) {
    return Array.from(items).filter((item) => item.kind === 'file').length;
}
/** Normalizes file entries while stopping one past the limit for atomic rejection. */
export async function filesFromDropItems(items, maxFiles) {
    const files = [];
    // Capture handles before the async directory walk yields and the browser protects drag data.
    const sources = Array.from(items).flatMap((item) => {
        if (item.kind !== 'file') {
            return [];
        }
        const entry = item.webkitGetAsEntry?.() ?? null;
        if (entry !== null && isFileSystemDirectoryEntry(entry)) {
            return [{ kind: 'directory', entry }];
        }
        const file = item.getAsFile();
        return file === null ? [] : [{ kind: 'file', file }];
    });
    for (const source of sources) {
        if (source.kind === 'directory') {
            files.push(...(await readFilesFromDirectory(source.entry, Math.max(0, maxFiles - files.length))));
        }
        else {
            files.push(source.file);
        }
        if (files.length > maxFiles) {
            break;
        }
    }
    return files;
}
//# sourceMappingURL=dropFiles.js.map